export default __webpack_public_path__ + "static/media/logo-us-ebay.ad49cc18.svg";